// J. Lore - jlore-motion.js
// GSAP-powered reveal-on-scroll system + Lenis smooth scroll (self-hosted).
// Content is ALWAYS visible by default: GSAP applies opacity only to elements
// it successfully tracks, so anything it misses stays visible (safe degradation).
// Respects prefers-reduced-motion and theme-editor design mode.

(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inDesignMode = !!(window.Shopify && window.Shopify.designMode);

  // Helper to wipe inline reveal state (for reduced-motion fallback)
  function revealAll() {
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
    document.querySelectorAll('[data-reveal-stagger] > *').forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }

  // Lenis smooth scroll (skip in reduced-motion / design mode)
  var lenis = null;
  var isTouchPrimary = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  if (!prefersReducedMotion && !inDesignMode && !isTouchPrimary) {
    window.addEventListener('load', function () {
      if (typeof Lenis === 'undefined') return;

      lenis = new Lenis({
        duration: 1.1,
        easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
        smoothWheel: true,
        touchMultiplier: 2
      });

      lenis.on('scroll', function () {
        if (window.ScrollTrigger) window.ScrollTrigger.update();
      });

      function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      }
      requestAnimationFrame(raf);

      window.JL_lenis = lenis;
    });
  }

  // GSAP reveal system (runs in design mode too, so editor preview shows animations)
  window.addEventListener('load', function () {
    if (prefersReducedMotion) {
      revealAll();
      return;
    }

    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      // GSAP failed to load - fail open so content is readable
      revealAll();
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    var ease = 'expo.out';

    // Single-element reveals
    gsap.utils.toArray('[data-reveal]').forEach(function (el) {
      var direction = el.dataset.reveal || 'up';
      var delay = parseFloat(el.dataset.revealDelay) || 0;
      var fromY = direction === 'up' ? 24 : direction === 'down' ? -24 : 0;
      var fromX = direction === 'left' ? 24 : direction === 'right' ? -24 : 0;

      gsap.fromTo(el,
        { opacity: 0, y: fromY, x: fromX },
        {
          opacity: 1,
          y: 0,
          x: 0,
          duration: 0.9,
          ease: ease,
          delay: delay,
          scrollTrigger: { trigger: el, start: 'top 85%', toggleActions: 'play none none none' }
        }
      );
    });

    // Stagger reveals for children of a container
    gsap.utils.toArray('[data-reveal-stagger]').forEach(function (container) {
      var children = container.children;
      if (!children || children.length === 0) return;
      var staggerAmount = parseFloat(container.dataset.staggerAmount) || 0.1;

      gsap.fromTo(children,
        { opacity: 0, y: 24 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: ease,
          stagger: staggerAmount,
          scrollTrigger: { trigger: container, start: 'top 82%', toggleActions: 'play none none none' }
        }
      );
    });

    // Subtle parallax on opt-in elements
    gsap.utils.toArray('[data-parallax]').forEach(function (el) {
      var speed = parseFloat(el.dataset.parallax) || 0.2;
      gsap.to(el, {
        yPercent: -speed * 30,
        ease: 'none',
        scrollTrigger: {
          trigger: el.parentElement,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });
    });

    // Fire a refresh in case layout shifted (e.g. web fonts swapped in after load)
    ScrollTrigger.refresh();
  });

  // Public API for dynamic sections (quick view, cart) to re-trigger
  window.JLore = window.JLore || {};
  window.JLore.refreshScrollTrigger = function () {
    if (window.ScrollTrigger) window.ScrollTrigger.refresh();
  };

  document.documentElement.classList.add('jl-motion-ready');
})();
